import { Logger, LoggerService } from "@Shared/logger";
import { EventMap } from "./models/event.types";
import { EventBus } from "./event_bus";
import { InitOptions } from "@Modules/options_module";
import { PerformanceTracker } from "./perf_tracker";
import { APP_EVENTS } from "@Core";
import { EventOptions } from "./models";
import { DataUtil } from "@Shared/utils";


export class EventModuleClass {
    private Logger: Logger = LoggerService.createLogger("EventModuleClass");

    private perfTracker: PerformanceTracker = new PerformanceTracker();
    get PerfTracker(): PerformanceTracker {
        return this.perfTracker;
    }

    private options: EventOptions;

    get Options(): EventOptions {
        return this.options;
    }

    get IsGAEnabled(): boolean {
        return this.options && this.options.GTMOptions && this.options.GTMOptions.enabled;
    }

    constructor() {        
        this.Logger.trace("****  CTOR ****");
    }

    public async init(opts: EventOptions): Promise<void> {
        this.Logger.trace("EventModule Initializing");
        try {
            if (!opts) {
                //no passed in options. 
                this.Logger.trace("no passed in options.");
            } else {
                this.options = opts;
                if (!this.options.trackPerformance) {
                    this.Logger.trace("Performance tracking is disabled. So call clearAllMeasures (since we start performance tracking at start until we get the config file from the server)");
                    this.PerfTracker.clearAllMeasures();
                }

                if (this.options.GTMOptions.enabled && this.options.GTMOptions.loadGTM) {
                    await this.loadGTM();
                }
            }

            this.Logger.trace("EventModule Initialized");
            return Promise.resolve();
        } catch (error) {
            throw error;

        }

    }

    public async loadGTM(): Promise<void> {

        Bus.emit(APP_EVENTS.onScriptLoadStart, { scriptName: "GTM" });
        const url = `https://www.googletagmanager.com/gtm.js?id=${this.options.GTMOptions.GTMId}`;
        return await DataUtil.loadScript(url).then((res) => {
            return Promise.resolve();
        }).catch((error) => {
            this.Logger.error("Error loading script", error);
            return Promise.reject(error);
        }).finally(() => {
            Bus.emit(APP_EVENTS.onScriptLoadEnd, { scriptName: "GTM" });
        });

    }

    public setPerformanceTracking(): void {
        this.Logger.trace("Setting Performance Tracking...");
        this.PerfTracker.trackBetween(APP_EVENTS.onInit, APP_EVENTS.onReady, 'appInit');
        this.PerfTracker.trackBetween(APP_EVENTS.onAuthStarted, APP_EVENTS.onAuthDetermined, 'authCheck');
        this.PerfTracker.trackBetween(APP_EVENTS.onLoginStarted, APP_EVENTS.onLogin, 'onLogin');
        this.PerfTracker.trackBetween(APP_EVENTS.onRegisterStarted, APP_EVENTS.onRegister, 'onRegister');
        this.PerfTracker.trackBetween(APP_EVENTS.onEntitlementStarted, APP_EVENTS.onEntitlementsDetermined, 'entitlementCheck');
        this.PerfTracker.trackBetweenDynamic(APP_EVENTS.onScriptLoadStart, APP_EVENTS.onScriptLoadEnd, 'scriptLoad', payload => payload.scriptName);
    }

}

LoggerService.setLogPrefix("%c<<MNG_Auth>>", "mng_auth_");
export const EventModule = new EventModuleClass();
export const Bus = new EventBus<EventMap>();